export function getPathSegments(path: string): string[] {
  return path.split('/').filter(Boolean);
}

export function getFeaturePath(path: string): string {
  const pathSegments = getPathSegments(path);
  return pathSegments.length > 1 ? `/${pathSegments.slice(1).join('/')}` : path;
}

export function getFirstPathSegment(path: string): string | undefined {
  const pathSegments = getPathSegments(path);
  return pathSegments.length > 0 ? pathSegments[0] : undefined;
}
